import { Database } from '../../adapters/database'
import { DexieDbUtils } from '../../utils/libs/dexieDbUtils'
const DBUtils = DexieDbUtils

class TransactionRepo {
  constructor(transactionsDb) {
    this.transactionsDb = transactionsDb
  }

  static async getDb() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return null
    let db = self.repositories?.transactionRepo
    if (!db) {
      db = await TransactionRepo.init()
      self.repositories.transactionRepo = db
    }
    return db
  }

  static async init() {
    const transactionsDb = await generateDbInstance('transactions')
    if (!transactionsDb) return null
    return new TransactionRepo(transactionsDb)
  }

  async get() {
    const transactions = await this.transactionsDb
      .sort('startTimestamp', -1)
      .find()
    return transactions
  }

  async findOne(reference) {
    let transaction = await this.transactionsDb.findOne(reference)
    return transaction
  }

  async save(data) {
    if (!Array.isArray(data) && !parseInt(data?.startTimestamp)) return
    await this.transactionsDb.save(data)
  }

  async clean() {
    await Promise.all([this.transactionsDb.deleteAll()])
  }
}

async function generateDbInstance(dbName) {
  const db = new Database()
  await db.init(DBUtils, dbName, {
    index: 'reference',
    otherIndexes: ['startTimestamp'],
  })
  return db
}

export { TransactionRepo }
